<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">{{ data.foodName }}</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>

<div class="my-2">
  <div>
    @if (imageUrls.length > 0) {
      <div>
        <div>
          <div>
            <button class="left-arr arrow-button" nz-tooltip="Previous" (click)="onPrev()">
              <em class="las la-arrow-circle-left" style="font-size: 36px"></em>
            </button>
            <button class="right-arr arrow-button" nz-tooltip="Next" (click)="onNext()">
              <em class="las la-arrow-circle-right" style="font-size: 36px"></em>
            </button>
          </div>
        </div>
        <ng-container>
          @if (isLoad) {
            <nz-spin nzSimple class="d-flex justify-content-center align-items-center" style="height: 30vh"></nz-spin>
          } @else {
            <img alt="image" [src]="currentImage" class="img-fluid"
              referrerpolicy="no-referrer">
          }
        </ng-container>
      </div>
    } @else {
      <img alt="image" [src]="data.images" class="img-fluid"
        referrerpolicy="no-referrer">
    }
  </div>
</div>
